import { gql } from "@apollo/client";

export const ADD_COMMENT = gql`
  mutation AddComment(
    $clientId: Int
    $processInstanceId: String
    $comment: String
    $isPrivate: Boolean
  ) {
    addComment(
      clientId: $clientId
      processInstanceId: $processInstanceId
      comment: $comment
      isPrivate: $isPrivate
    ) {
      id
      createTime
      clientId
      processInstanceId
      description
      isPrivate
      createdByUserId
      createdByUser {
        firstName
        lastName
        userName
        email
        clientId
      }
    }
  }
`;
